import scrollFrame from "../../setup/js/_scrollFrame.2";
import scrollWatch from "../../setup/js/_scrollWatch.2";
$(document).on(
  "metaslug_sinhnhat1tuoi_float_left rendered", {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    scrollFrame.init();
    scrollWatch.init({
      options: {
        onElementInView: function (e) {
          var $this = $(e.el).parents("[data-block-id]");
          var dataBlockId = $this.attr("data-block-id");
          //console.log(dataBlockId);
          $(`.nav-left--item[data-fts-selector='data-block-id="${dataBlockId}"']`);
          $(`[data-fts-selector]`).removeClass("active");
          $(`[data-fts-selector='[data-block-id="${dataBlockId}"]']`).addClass(
            "active"
          );
        },
        onElementOutOfView: function (e) {
          var $this = $(e.el).parents("[data-block-id]");
          var dataBlockId = $this.attr("data-block-id");
          // console.log(dataBlockId);
          $(
            `[data-fts-selector='[data-block-id="${dataBlockId}"]']`
          ).removeClass("active");
        },
      },
    });
  }
);